import React from "react";
import Button from "@material-ui/core/Button";
import CssBaseline from "@material-ui/core/CssBaseline";
import TextField from "@material-ui/core/TextField";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";

import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';

import {BrowserRouter as Router , Switch, Route, Link} from 'react-router-dom';


import { Formik, Form } from "formik";
import * as yup from "yup";

let ActivitiesSchema = yup.object().shape({
  ResidentId: yup.string().required("This field is required."),
  FirstName: yup.string().required("This field is required."),
  MiddleName: yup.string().required("This field is required."),
  LastName: yup.string().required("This field is required."),
  AddressLine1: yup.string().required("This field is required."),
  AddressLine2: yup.string().required("This field is required."),
  City: yup.string().required("This field is required."),
  State: yup.string().required("This field is required."),
  Zip: yup.string().required("This field is required."),
  Gender: yup.string().required("This field is required."),
  DOB: yup.string().required("This field is required."),
  Email: yup.string().required("This field is required."),
  Phone: yup.string().required("This field is required."),
});

const useStyles = makeStyles(theme => ({
  "@global": {
    body: {
      backgroundColor: theme.palette.common.white
    }
  },
  paper: {
    marginTop: theme.spacing(8),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    '& h2, h3, h4':{
      textAlign: 'left !important',
      color: '#999 !important',
    }
    
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(3)
  },
  submit: {
    margin: theme.spacing(3, 0, 2)
  },
  
}));

export const AdminActivityForm = () => {
  const classes = useStyles();

  return (
    <Container component="main" maxWidth="lg">
      <Link to={'/admin/activities'}  >
          <Button color="primary">Back to Activities Admin</Button>
      </Link>
      <CssBaseline />
      <div className={classes.paper}>
        <Typography component="h1" variant="h5">
          Activities Form
        </Typography>
        <Formik
          initialValues={{
            firstName: "",
            lastName: "",
            email: "",
            password: ""
          }}
          validationSchema={ActivitiesSchema}
          onSubmit={values => {
            console.log(values);
          }}
        >
          {({ errors, handleChange, touched }) => (
            <Form className={classes.form}>
              <Grid container spacing={2}>

                {/*
                ActivityType	ActivityDesc	icon
                */}
              <Grid item xs={12}><h3>Activity Info</h3></Grid>
                
              <Grid item xs={12} sm={4}>
                  <TextField
                    error={errors.firstName && touched.firstName}
                    autoComplete="fname"
                    name="firstName"
                    variant="outlined"
                    fullWidth
                    onChange={handleChange}
                    id="firstName"
                    label="ActivityType"
                    autoFocus
                    helperText={
                      errors.firstName && touched.firstName
                        ? errors.firstName
                        : null
                    }
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <TextField
                    error={errors.MiddleName && touched.MiddleName}
                    autoComplete="mname"
                    name="MiddleName"
                    variant="outlined"
                    fullWidth
                    onChange={handleChange}
                    id="ActivityDesc"
                    label="ActivityDesc"
                    autoFocus
                    helperText={
                      errors.MiddleName && touched.MiddleName
                        ? errors.MiddleName
                        : null
                    }
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <TextField
                    error={errors.lastName && touched.lastName}
                    variant="outlined"
                    fullWidth
                    onChange={handleChange}
                    id="lastName"
                    label="icon"
                    name="lastName"
                    autoComplete="lname"
                    helperText={
                      errors.lastName && touched.lastName
                        ? errors.lastName
                        : null
                    }
                  />
                </Grid>
               

              </Grid>
              <Button
                type="submit"
                fullWidth
                variant="contained"
                color="primary"
                className={classes.submit}
              >
                Submit
              </Button>
            </Form>
          )}
        </Formik>
      </div>
    </Container>
  );
};
